module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG76b5cec0ba6cd1ae5ddab11d0fe2ba92.76b5cec0.png";